import axios from "axios";

const deployEnvironment = "production"; // "staging" or "production"
const env = process.env.NODE_ENV === "production" ? deployEnvironment : "local";

const urls = {
  production: "https://us-central1-leaderboard-system.cloudfunctions.net/api",
  staging: "https://us-central1-leaderboard-system-dev.cloudfunctions.net/api",
  local: "http://localhost:4000",
};

const emailUrls = {
  production: "https://us-central1-leaderboard-system.cloudfunctions.net",
  staging: "https://us-central1-leaderboard-system-dev.cloudfunctions.net",
  local: "https://us-central1-leaderboard-system-dev.cloudfunctions.net",
};

const instance = axios.create({
  baseURL: urls[env],
});

export const emailService = axios.create({
  baseURL: emailUrls[env],
});

export default instance;
